// import React, { useState } from 'react';
// import {
//     Drawer,
//     Typography,
//     Button,
//     Box,
//     IconButton,
//     Divider,
//     Input,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';

// const ImportUsersPopup = ({ open, onClose, onImport }) => {
//     const [selectedFile, setSelectedFile] = useState(null);

//     const handleFileUpload = (event) => {
//         const file = event.target.files[0];
//         setSelectedFile(file);
//     };

//     const handleImport = () => {
//         if (onImport && selectedFile) {
//             onImport(selectedFile);
//         }
//         onClose();
//     };

//     return (
//         <Drawer
//             anchor="right"
//             open={open}
//             onClose={onClose}
//             PaperProps={{
//                 sx: { width: '450px' },
//             }}
//         >
//             {/* Header */}
//             <Box
//                 sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '16px',
//                     borderBottom: '1px solid #e0e0e0',
//                 }}
//             >
//                 <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                     Import Users
//                 </Typography>
//                 <Button
//                     onClick={onClose}
//                     style={{
//                         position: 'absolute',
//                         top: '-10px',
//                         left: '-50px',
//                         backgroundColor: '#fff',
//                         borderRadius: '50%',
//                         boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//                         minWidth: '40px',
//                         height: '40px',
//                         padding: '8px',
//                         zIndex: 1,
//                     }}
//                 >
//                     <CloseIcon />
//                 </Button>
//             </Box>

//             {/* Content */}
//             <Box sx={{ padding: '16px' }}>
//                 {/* SSO Section */}
//                 <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
//                     Connect via SSO
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
//                     <Button
//                         variant="outlined"
//                         startIcon={<img src="https://img.icons8.com/color/48/000000/google-logo.png" alt="Google" style={{ width: 20, height: 20 }} />}
//                     >
//                         Continue with Google
//                     </Button>
//                     <Button
//                         variant="outlined"
//                         startIcon={<img src="https://img.icons8.com/color/48/000000/microsoft.png" alt="Microsoft" style={{ width: 20, height: 20 }} />}
//                     >
//                         Continue with Microsoft
//                     </Button>
//                 </Box>

//                 <Divider sx={{ marginBottom: '24px' }} />

//                 {/* CSV Upload Section */}
//                 <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
//                     Add CSV
//                 </Typography>
//                 <Box
//                     sx={{
//                         border: '2px dashed #9e9e9e',
//                         borderRadius: '8px',
//                         padding: '16px',
//                         textAlign: 'center',
//                         marginBottom: '24px',
//                     }}
//                 >
//                     <CloudUploadOutlinedIcon sx={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '8px' }} />
//                     <Typography variant="body2" sx={{ marginBottom: '8px' }}>
//                         Drag & Drop CSV
//                     </Typography>
//                     <Typography variant="body2" sx={{ marginBottom: '8px', color: '#757575' }}>
//                         or
//                     </Typography>
//                     <Typography
//                         variant="contained"
//                         component="label"
//                         sx={{
//                             color: '#ff0083'
//                         }}
//                         onChange={handleFileUpload}

//                     >
//                         add file

//                     </Typography>
//                 </Box>

//                 {/* Show selected file */}
//                 {selectedFile && (
//                     <Typography
//                         variant="body2"
//                         sx={{ marginBottom: '24px', color: '#4caf50' }}
//                     >
//                         Selected File: {selectedFile.name}
//                     </Typography>
//                 )}
//             </Box>

//             {/* Footer */}
//             <Box
//                 sx={{
//                     padding: '16px',
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                     borderTop: '1px solid #e0e0e0',
//                 }}
//             >
//                 <Button
//                     variant="contained"
//                     onClick={handleImport}
//                     disabled={!selectedFile}
//                     sx={{
//                         backgroundColor: '#ff0083',
//                         color: 'white',
//                         '&:hover': {
//                             backgroundColor: '#e00074',
//                         },
//                     }}
//                 >
//                     Import
//                 </Button>
//             </Box>
//         </Drawer>
//     );
// };

// export default ImportUsersPopup;
// import React, { useState } from 'react';
// import {
//   Drawer,
//   Typography,
//   Button,
//   Box,
//   Divider,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
// import './AddUserPopup.css'; // Reuse the same styles

// const ImportUsersPopup = ({ open, onClose, onImport }) => {
//   const [selectedFile, setSelectedFile] = useState(null);

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     setSelectedFile(file);
//   };

//   const handleImport = () => {
//     if (onImport && selectedFile) {
//       onImport(selectedFile);
//     }
//     onClose();
//   };

//   return (
//     <Drawer
//       anchor="right"
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: { width: '500px', height: '550px' },
//         style: { overflow: 'visible', margin: '20px 0px 20px 20px' },
//       }}
//     >
//       {/* Header */}
//       <div className="drawer-header-user" style={{ padding: '16px', position: 'relative' }}>
//         <Typography
//           // style={{
//           //   fontFamily: 'Barlow Condensed',
//           //   fontWeight: 500,
//           //   fontSize: '24px',
//           // }}

//           variant="h5"
//           sx={{ fontWeight: 600, fontSize: '22px' }}
    
//         >
//           Import Users
//         </Typography>
        
//         <Button
//           onClick={onClose}
//           style={{
//             position: 'absolute',
//             top: '-1px',
//             left: '-50px',
//             backgroundColor: '#fff',
//             borderRadius: '50%',
//             boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//             minWidth: '40px',
//             height: '40px',
//             padding: '8px',
//             zIndex: 1,
//           }}
//         >
//           <CloseIcon style={{ color: 'black' }} />
//         </Button>
//       </div>

//       {/* Content */}
//       <div style={{ padding: '16px' }}>
//         {/* SSO Section */}
//         <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
//           Connect via SSO
//         </Typography>
//         <Box sx={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
//           <Button
//             variant="outlined"
//             startIcon={
//               <img
//                 src="https://img.icons8.com/color/48/000000/google-logo.png"
//                 alt="Google"
//                 style={{ width: 20, height: 20 }}
//               />
//             }
//           >
//             Continue with Google
//           </Button>
//           <Button
//             variant="outlined"
//             startIcon={
//               <img
//                 src="https://img.icons8.com/color/48/000000/microsoft.png"
//                 alt="Microsoft"
//                 style={{ width: 20, height: 20 }}
//               />
//             }
//           >
//             Continue with Microsoft
//           </Button>
//         </Box>

//         <Divider sx={{ marginBottom: '24px' }} />

//         {/* CSV Upload Section */}
//         <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
//           Add CSV
//         </Typography>
//         <Box
//           sx={{
//             border: '2px dashed #9e9e9e',
//             borderRadius: '8px',
//             padding: '16px',
//             textAlign: 'center',
//             marginBottom: '24px',
//           }}
//         >
//           <CloudUploadOutlinedIcon sx={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '8px' }} />
//           <Typography variant="body2" sx={{ marginBottom: '8px' }}>
//             Drag & Drop CSV
//           </Typography>
//           <Typography variant="body2" sx={{ marginBottom: '8px', color: '#757575' }}>
//             or
//           </Typography>
//           <label
//             htmlFor="file-upload"
//             style={{ color: '#ff0083', cursor: 'pointer' }}
//           >
//             add file
//           </label>
//           <input
//             id="file-upload"
//             type="file"
//             style={{ display: 'none' }}
//             accept=".csv"
//             onChange={handleFileUpload}
//           />
//         </Box>

//         {/* Show selected file */}
//         {selectedFile && (
//           <Typography
//             variant="body2"
//             sx={{ marginBottom: '24px', color: '#4caf50' }}
//           >
//             Selected File: {selectedFile.name}
//           </Typography>
//         )}
//       </div>

//       {/* Footer */}
//       <div
//         style={{
//           position: 'absolute',
//           bottom: '0',
//           right: '0',
//           width: '100%',
//           padding: '16px',
//           display: 'flex',
//           justifyContent: 'flex-end',
//         }}
//       >
//         <Button
//           style={{ backgroundColor: '#ff0083', color: 'white', marginRight: '8px' }}
//           onClick={handleImport}
//           disabled={!selectedFile}
//         >
//           Import
//         </Button>
//       </div>
//     </Drawer>
//   );
// };

// export default ImportUsersPopup;
// import React, { useState } from 'react';
// import {
//   Drawer,
//   Typography,
//   Button,
//   Box,
//   Divider,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
// import './AddUserPopup.css'; // Optional: your existing styles

// const ImportUsersPopup = ({ open, onClose, onImport }) => {
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [csvData, setCsvData] = useState([]);

//   // Handle CSV file upload and parsing
//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     setSelectedFile(file);

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const text = e.target.result;
//       const rows = text.split('\n').filter(r => r.trim() !== '');

//       if (rows.length === 0) return;

//       const headers = rows[0].split(',').map(h => h.trim());
//       const data = rows.slice(1).map(row => {
//         const values = row.split(',');
//         return headers.reduce((acc, header, index) => {
//           acc[header] = values[index]?.trim();
//           return acc;
//         }, {});
//       });

//       setCsvData(data);
//     };

//     reader.readAsText(file);
//   };

//   // Import action
//   const handleImport = () => {
//     if (onImport && selectedFile) {
//       onImport(selectedFile);
//     }
//     onClose();
//   };

//   return (
//     <Drawer
//       anchor="right"
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: { width: '500px', height: '550px' },
//         style: { overflow: 'visible', margin: '20px 0px 20px 20px' },
//       }}
//     >
//       {/* Header */}
//       <div className="drawer-header-user" style={{ padding: '16px', position: 'relative' }}>
//         <Typography variant="h5" sx={{ fontWeight: 600, fontSize: '22px' }}>
//           Import Users
//         </Typography>

//         <Button
//           onClick={onClose}
//           style={{
//             position: 'absolute',
//             top: '-1px',
//             left: '-50px',
//             backgroundColor: '#fff',
//             borderRadius: '50%',
//             boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//             minWidth: '40px',
//             height: '40px',
//             padding: '8px',
//             zIndex: 1,
//           }}
//         >
//           <CloseIcon style={{ color: 'black' }} />
//         </Button>
//       </div>

//       {/* Content */}
//       <div style={{ padding: '16px' }}>
//         {/* SSO Section */}
//         <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
//           Connect via SSO
//         </Typography>
//         <Box sx={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
//           <Button
//             variant="outlined"
//             startIcon={
//               <img
//                 src="https://img.icons8.com/color/48/000000/google-logo.png"
//                 alt="Google"
//                 style={{ width: 20, height: 20 }}
//               />
//             }
//           >
//             Continue with Google
//           </Button>
//           <Button
//             variant="outlined"
//             startIcon={
//               <img
//                 src="https://img.icons8.com/color/48/000000/microsoft.png"
//                 alt="Microsoft"
//                 style={{ width: 20, height: 20 }}
//               />
//             }
//           >
//             Continue with Microsoft
//           </Button>
//         </Box>

//         <Divider sx={{ marginBottom: '24px' }} />

//         {/* CSV Upload Section */}
//         <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
//           Add CSV
//         </Typography>
//         <Box
//           sx={{
//             border: '2px dashed #9e9e9e',
//             borderRadius: '8px',
//             padding: '16px',
//             textAlign: 'center',
//             marginBottom: '24px',
//           }}
//         >
//           <CloudUploadOutlinedIcon sx={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '8px' }} />
//           <Typography variant="body2" sx={{ marginBottom: '8px' }}>
//             Drag & Drop CSV
//           </Typography>
//           <Typography variant="body2" sx={{ marginBottom: '8px', color: '#757575' }}>
//             or
//           </Typography>
//           <label
//             htmlFor="file-upload"
//             style={{ color: '#ff0083', cursor: 'pointer' }}
//           >
//             add file
//           </label>
//           <input
//             id="file-upload"
//             type="file"
//             style={{ display: 'none' }}
//             accept=".csv"
//             onChange={handleFileUpload}
//           />
//         </Box>

//         {/* Show selected file */}
//         {selectedFile && (
//           <Typography
//             variant="body2"
//             sx={{ marginBottom: '16px', color: '#4caf50' }}
//           >
//             Selected File: {selectedFile.name}
//           </Typography>
//         )}

//         {/* CSV Preview */}
//         {csvData.length > 0 && (
//           <Box sx={{ marginTop: '16px' }}>
//             <Typography
//               variant="subtitle2"
//               sx={{ fontWeight: 600, marginBottom: '8px' }}
//             >
//               Preview ({Math.min(csvData.length, 5)} rows)
//             </Typography>

//             <Box
//               sx={{
//                 maxHeight: '180px',
//                 overflowY: 'auto',
//                 border: '1px solid #e0e0e0',
//                 borderRadius: '6px',
//               }}
//             >
//               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                 <thead style={{ background: '#f5f5f5' }}>
//                   <tr>
//                     {Object.keys(csvData[0]).map((key) => (
//                       <th
//                         key={key}
//                         style={{
//                           padding: '8px',
//                           fontSize: '12px',
//                           textAlign: 'left',
//                           borderBottom: '1px solid #e0e0e0'
//                         }}
//                       >
//                         {key}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {csvData.slice(0, 5).map((row, index) => (
//                     <tr key={index}>
//                       {Object.values(row).map((value, i) => (
//                         <td
//                           key={i}
//                           style={{
//                             padding: '8px',
//                             fontSize: '12px',
//                             borderBottom: '1px solid #f0f0f0'
//                           }}
//                         >
//                           {value}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </Box>
//           </Box>
//         )}
//       </div>

//       {/* Footer */}
//       <div
//         style={{
//           position: 'absolute',
//           bottom: '0',
//           right: '0',
//           width: '100%',
//           padding: '16px',
//           display: 'flex',
//           justifyContent: 'flex-end',
//         }}
//       >
//         <Button
//           style={{ backgroundColor: '#ff0083', color: 'white', marginRight: '8px' }}
//           onClick={handleImport}
//           disabled={!selectedFile}
//         >
//           Import
//         </Button>
//       </div>
//     </Drawer>
//   );
// };

// export default ImportUsersPopup;
import React, { useState } from 'react';
import axios from 'axios';
import {
  Drawer,
  Typography,
  Button,
  Box,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';

const ImportUsersPopup = ({ open, onClose, orgID }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alertMsg, setAlertMsg] = useState(null); // { type: 'success'|'error', text: '' }

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    setAlertMsg(null);

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const rows = text.split('\n').filter(r => r.trim());

      const headers = rows[0].split(',').map(h => h.trim());
      const data = rows.slice(1).map(row => {
        const values = row.split(',');
        return headers.reduce((acc, header, index) => {
          acc[header] = values[index]?.trim();
          return acc;
        }, {});
      });

      setCsvData(data);
    };

    reader.readAsText(file);
  };

  const handleImport = async () => {
    if (!selectedFile || csvData.length === 0) return;

    const resolvedOrgID = orgID || sessionStorage.getItem('loggedInUser');

    setLoading(true);
    setAlertMsg(null);
    try {
      const res = await axios.post('/auth/bulkAddAgents', {
        agents: csvData,
        orgID: resolvedOrgID
      });
      const msg = res.data?.message || 'Import successful';
      setAlertMsg({ type: 'success', text: msg });
      // Reset after short delay so user sees confirmation
      setTimeout(() => {
        setSelectedFile(null);
        setCsvData([]);
        setAlertMsg(null);
        onClose();
      }, 2000);
    } catch (err) {
      const errMsg = err.response?.data?.message || err.response?.data?.error || err.message || 'Import failed';
      setAlertMsg({ type: 'error', text: errMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 520,
          height: 'calc(100vh - 40px)',
          margin: '20px 0px 20px',
          overflow: 'visible', // 👈 important
          flexDirection: 'column',
        },
      }}
    >
    <Button
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 17,
            left: -48,
            minWidth: 36,
            height: 36,
            borderRadius: '50%',
            backgroundColor: '#F5F5F5',
            '&:hover': { backgroundColor: '#E0E0E0' },
          }}
        >
          <CloseIcon />
        </Button>
      {/* Header */}
      <Box sx={{ p: 3, position: 'relative' }}>
        <Typography sx={{ fontSize: 22, fontWeight: 600 }}>
          Import Users
        </Typography>

        
      </Box>

      <Divider />

      {/* Content */}
      <Box sx={{ px: 3, py: 2, flex: 1, overflowY: 'auto' }}>
        {/* SSO */}
        <Typography sx={{ fontWeight: 500, mb: 2 }}>
          Connect via SSO
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={
              <img
                src="https://img.icons8.com/color/48/google-logo.png"
                alt="Google"
                width={18}
              />
            }
            sx={{
              height: 44,
              borderRadius: 2,
              textTransform: 'none',
              borderColor: '#D0D5DD',
                  color: 'black',       

            }}
          >
            Continue with Google
          </Button>

          {/* <Button
            variant="outlined"
            fullWidth
            startIcon={
              <img
                src="https://img.icons8.com/color/48/microsoft.png"
                alt="Microsoft"
                width={18}
              />
            }
            sx={{
              height: 44,
              borderRadius: 2,
              textTransform: 'none',
              borderColor: '#D0D5DD',
                  color: 'black',        // <-- make text black

            }}
          >
            Continue with Microsoft
          </Button> */}
          <Button
            variant="outlined"
            fullWidth
            startIcon={
              <img
                src="https://img.icons8.com/color/48/microsoft.png"
                alt="Microsoft"
                width={18}
              />
            }
            sx={{
              height: 44,
              borderRadius: 2,
              textTransform: 'none',
              borderColor: '#D0D5DD',
              color: 'black',
              display: 'flex',         // make sure content is flex
              alignItems: 'center',    // vertically center icon + text
              justifyContent: 'center',// horizontally center text + icon
              whiteSpace: 'nowrap',    // prevent text from wrapping
            }}
          >
            Continue with Microsoft
          </Button>

        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* CSV Upload */}
        <Typography sx={{ fontWeight: 500, mb: 2 }}>
          Add CSV
        </Typography>

        <Box
          sx={{
            border: '2px dashed #E0E0E0',
            borderRadius: 3,
            p: 4,
            textAlign: 'center',
            backgroundColor: '#FAFAFA',
          }}
        >
          <CloudUploadOutlinedIcon sx={{ fontSize: 42, color: '#9E9E9E' }} />

          <Typography sx={{ mt: 1, fontSize: 14 }}>
            Drag & Drop CSV
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent:'center', gap: 1, my: 1 }}>
  <Typography sx={{ fontSize: 13, color: '#757575' }}>or</Typography>
  <label
    htmlFor="csv-upload"
    style={{ color: '#FF007A', cursor: 'pointer', fontWeight: 500 }}
  >
    add file
  </label>
</Box>


          <input
            id="csv-upload"
            type="file"
            accept=".csv"
            hidden
            onChange={handleFileUpload}
          />
        </Box>

        {/* Selected File */}
        {/* {selectedFile && (
          <Typography sx={{ mt: 2, color: '#000000DE', fontSize: 14, }}>
            Manage Table 
          </Typography>
        )} */}

        {/* Preview */}
        {csvData.length > 0 && (
          <Box sx={{ mt: 3 }}>
            <Typography sx={{ fontWeight: 600, mb: 1 , backgroundColor:"#FAFAFA"}}>
              Manage table 
            </Typography>

            <Box
              sx={{
                border: '1px solid #E0E0E0',
                borderRadius: 2,
                maxHeight: 180,
                overflowY: 'auto',
              }}
            >
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ background: '#F9FAFB' }}>
                  <tr>
                    {Object.keys(csvData[0]).map((key) => (
                      <th
                        key={key}
                        style={{
                          padding: 10,
                          fontSize: 12,
                          textAlign: 'left',
                          color: '#667085',
                        }}
                      >
                        {key}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {csvData.slice(0, 5).map((row, i) => (
                    <tr key={i}>
                      {Object.values(row).map((val, j) => (
                        <td
                          key={j}
                          style={{
                            padding: 10,
                            fontSize: 12,
                            color: '#344054',
                            borderTop: '1px solid #F0F0F0',
                          }}
                        >
                          {val}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </Box>
        )}
      </Box>

      {/* Alert banner */}
      {alertMsg && (
        <Box
          sx={{
            mx: 3,
            mb: 1,
            px: 2,
            py: 1.2,
            borderRadius: 2,
            fontSize: 13,
            backgroundColor: alertMsg.type === 'success' ? '#E6F4EA' : '#FDECEA',
            color: alertMsg.type === 'success' ? '#2E7D32' : '#C62828',
            border: `1px solid ${alertMsg.type === 'success' ? '#A5D6A7' : '#EF9A9A'}`,
          }}
        >
          {alertMsg.text}
        </Box>
      )}

      {/* Footer */}
      <Box
        sx={{
          borderTop: '1px solid #E0E0E0',
          p: 2,
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          onClick={handleImport}
          disabled={!selectedFile || loading}
          sx={{
            backgroundColor: '#FC350B',
            color: '#fff',
            height: 40,
            px: 3,
            borderRadius: 2,
            textTransform: 'none',
            '&:hover': { backgroundColor: '#E6006F' },
            '&.Mui-disabled': { backgroundColor: '#ccc', color: '#fff' },
          }}
        >
          {loading ? 'Importing...' : 'Import'}
        </Button>
      </Box>
    </Drawer>
  );
};

export default ImportUsersPopup;
